import { useEffect } from 'react';
import { useStoreId } from '@thd-nucleus/experience-context';
import { useDataModel } from '@thd-nucleus/data-sources';
import { determineItemOrItemTypes } from './utils';

export const useIsMajorAppliance = ({
  itemId,
  itemIds,
  storeId,
  responseOnly,
  isMajorAppliance
}) => {
  const storeIdToUse = storeId || useStoreId();

  if (typeof isMajorAppliance === 'boolean') {
    return {
      isMajorApplianceItemOrItems: isMajorAppliance,
      loading: null,
      error: null
    };
  }

  if (responseOnly || isMajorAppliance) {
    return {
      isMajorApplianceItemOrItems: isMajorAppliance || null,
      loading: null,
      error: null
    };
  }

  const [getProducts, productsResponse] = useDataModel('clientOnlyProducts', {
    variables: {
      itemIds: (itemId ? [itemId] : itemIds)
    },
    ssr: false,
    skip: storeIdToUse === '8119'
  }, true);
  useEffect(() => {
    getProducts();
  }, [itemIds, itemId]);
  const { data, loading, error } = productsResponse;

  return {
    isMajorApplianceItemOrItems: determineItemOrItemTypes(data),
    loading,
    error
  };
};
